<template>
 <div class="s4s-page">
    <div class="s4s-tips">
      <img src="../assets/icon/tips.png" class="s4s-tips-iamge" />
      <div class="s4s-tips-right">
        <div>交通违法代办的办理周期为1-2个工作日,部分地区2-5个工作日。
          <span style="color: #3A82FF;">需年检的用户如需当日处理完成请勿下单</span>。其他问题请参见
        <span style="color: #24252D;text-decoration: underline;" @click="gotoHelp">常见问题</span>。
        </div>
      </div>
    </div>
      <div class="attention-important" v-if="DzyNotice"
       @click="handleShowNotice">
          <img src="../assets/icon/notice_icon.png"
          style="width:14px;height:14px;margin-right:5px;"/>
          {{DzyNotice.Title}}
          <img src="../assets/icon/notice_icon_right.png"
          style="width:8px;height:12px;margin-left:10px;"/>
      </div>
      <div class="s4s-pay-body">
        <div :class="isPhoneTrue ? 's4s-group' : 's4s-group s4s-group-error'">
          <span class="s4s-group-tit">手机号码</span>
          <span v-if="tel" class="s4s-group-txt">{{ phone }}</span>
          <input v-else v-model="phone" type="number"
          name="mobile" placeholder="请输入手机号码" maxlength="11"/>
        </div>
        <div class="s4s-group">
          <span class="s4s-group-tit">认罚日期</span>
          <span class="s4s-group-txt">{{ date }}</span>
        </div>
        <div class="s4s-group">
          <span class="s4s-group-tit">车牌号码</span>
          <span class="s4s-group-txt">{{ illegal.CarNo }}</span>
        </div>
        <div v-if="showName" :class="isNameTrue ? 's4s-group' : 's4s-group s4s-group-error'" >
          <span class="s4s-group-tit">中文姓名</span>
          <input type="text" v-model="name" name="name" placeholder="请输入姓名" />
          <!-- <span class="s4s-help" bind:tap="openDriveNo"></span> -->
        </div>
        <div :class="isDriveNoTrue ? 's4s-group' : 's4s-group s4s-group-error'"
        v-if="illegal.FreeRuleObject && illegal.FreeRuleObject.drive_no == 1"
        >
          <span class="s4s-group-tit">驾驶证号</span>
          <input type="number" v-model="driveNo" name="driveNo" placeholder="请输入驾驶证号码" />
          <!-- <span class="s4s-help" bind:tap="openDriveNo"></span> -->
        </div>
        <div :class="isDriveFileNoTrue ? 's4s-group' : 's4s-group s4s-group-error'"
          v-if="illegal.FreeRuleObject && illegal.FreeRuleObject.drive_file_number == 1"
        >
          <span class="s4s-group-tit">行驶证档案号</span>
          <input type="number" v-model="driveFileNo"
          name="driveFileNo" placeholder="请输入行驶证档案号码" />
          <span class="s4s-help" bind:tap="openDriveFileNo"></span>
        </div>
        <div :class="isDriveBarCodeTrue ? 's4s-group' : 's4s-group s4s-group-error'"
        v-if="illegal.FreeRuleObject && illegal.FreeRuleObject.drive_bar_code == 1"
        >
          <span class="s4s-group-tit">行驶证条码号</span>
          <input type="number" v-model="driveBarCode"
          name="driveBarCode" placeholder="请输入行驶证条形码编号" />
          <span class="s4s-help" bind:tap="openDriveBarCode"></span>
        </div>
        <canvas id="canvas" width="0px" height="0px" style="display: none"></canvas>
        <input type="file" accept="image/*" @change="uploader" ref="file" style="display: none;">
        <div
          :class="isDriveFileTrue ?
          's4s-group  group-upload'
          : 's4s-group group-upload s4s-group-error'"
          v-if="(illegal.FreeRuleObject && illegal.FreeRuleObject.drive_licence == 1)
          || (illegal.FreeRuleObject && illegal.FreeRuleObject.travel_licence == 1)"
          style="height:auto">
          <div class="s4s-group-tit">上传行驶证</div>
          <div style="flex:1;display: flex;">
            <img
              :src="driveUrl||require('../assets/icon/uplaod1.png')"
              style="background:#eee;width: 90px;height: 70px;"
              mode="scaleToFill"
              @click="chooseImage('driveUrl')" />
               <img
              :src="travelUrl||require('../assets/icon/uplaod2.png')"
              style="background:#eee;width: 90px;height: 70px;margin-left: 10px;"
              mode="scaleToFill"
              @click="chooseImage('travelUrl')" />
          </div>
          <span
            class="s4s-help"
            bind:tap="open1"></span>
        </div>
        <div
          :class="isJsDriveFileTrue
          ?'s4s-group  group-upload'
          :'s4s-group group-upload s4s-group-error'"
          v-if="(illegal.FreeRuleObject && illegal.FreeRuleObject.jsz_drive_licence == 1) ||
          (illegal.FreeRuleObject && illegal.FreeRuleObject.jsz_travel_licence == 1)"
          style="height:auto">
          <div class="s4s-group-tit">上传驾驶证</div>
          <div style="flex:1;display: flex;">
            <img
              :src="JSZDriveUrl||require('../assets/icon/uplaod1.png')"
              style="background:#eee;width: 90px;height: 70px;"
              @click="chooseImage('JSZDriveUrl')" />
               <img
              :src="JSZTravelUrl||require('../assets/icon/uplaod2.png')"
              style="background:#eee;width: 90px;height: 70px;margin-left: 10px;"
              @click="chooseImage('JSZTravelUrl')" />
          </div>
          <span
            class="s4s-help"
            bind:tap="open2"></span>
        </div>
        <div class="s4s-group">
          <span class="s4s-group-tit">罚款金额</span>
          <span class="s4s-group-txt">￥ {{ price.toFixed(2) }}</span>
        </div>
        <div class="s4s-group">
          <span class="s4s-group-tit">服务费用：</span>
          <span class="s4s-group-txt"  style="color:#FFAF30;" >
            ￥ {{ ((ownFree || 0) / 100).toFixed(2) }}
          </span>
        </div>
        <div class="s4s-group" @click="gotoCoupon">
          <span class="s4s-group-tit">优惠券</span>
          <span v-if="useCoupon" class="s4s-group-txt" style="color:#FD2900;">- ￥{{ ((couponFee || 0) / 100).toFixed(2) }}</span>
          <span v-else :class="couponLen > 0 ? 's4s-group-txt s4s-user-btn red':'s4s-group-txt s4s-user-btn'" >您有{{couponLen}}张可使用优惠券<img src="../assets/icon/right_arr.png" mode="aspectFit" class="s4s-right-arr"/></span>
        </div>
      </div>
      <div v-if="error" class="s4s-error">{{error}}</div>
      <div class="s4s-mask" bind:tap="closeMake" v-if="openShow">
        <img src="src" class="s4s-mask-image" mode="aspectFit"/>
      </div>
      <div style="height: 52px;"></div>
      <div class="s4s-pay">
        <div class="s4s-pay-container">
          <div class="s4s-pay-btn" >
              <div class="s4s-pay-text">合计金额：
                <span style="color:#fd2900;font-weight: bold;">
                  ￥ {{ (((price * 100 + ownFree + lateFree- (couponFee || 0) ) || 0) / 100).toFixed(2) }}
                </span>
              </div>
              <div class="s4s-pay-tip">预计1-5个工作日办理完成 </div>
          </div>
          <div class="s4s-pay-btn" @click="formSubmit"
            :style="{backgroundImage:advertisingShow.backgroundImage}">
              立即办理
          </div>
        </div>
      </div>
    <!-- 扫码付款 start -->
    <div class="s4s-mask-pay" @click="closePay" v-if="showpay">
      <p>请扫码付款</p>
      <img :src="paysrc" />
    </div>
    <!-- 扫码付款 end -->
    <a ref="newWebpay"></a>

    <Pay v-on:confirm="GenerateOrders"
    v-on:cancel="showDialog = false"
    v-on:change="changeType"
    :selected="payType"
    :showDialog="showDialog" :alipay="true" :wechat="showWeixinPay" />

    <!-- 付款返回 start -->
     <Confirm
    :show-dialog="showPayEnd"
    :ok-text="'支付完成'"
    :cancel-text="'重新支付'"
    :title="'支付确认'"
    :content="'若未完成支付，请点击重新支付。'"
    v-on:confirm="confirmFn"
    v-on:cancel="showPayEnd = false"
  />
    <!-- 付款返回 end -->

</div>
</template>

<script>
// @ is an alias to /src
import Pay from '@/components/Pay.vue';
import Confirm from '@/components/Confirm.vue';
import advertisingShow from './../utils/advertising';

export default {
  name: 'illegalPay',
  components: {
    Pay,
    Confirm,
  },
  data() {
    return {
      showWeixinPay: true,
      carno: '',
      date: '',
      price: 0,
      openShow: false,
      ownFree: 0,
      lateFree: 0,
      illegal: {},
      driveUrl: '',
      travelUrl: '',
      provice: '',
      user: {},
      tel: '',
      phone: '',
      JSZTravelUrl: '',
      JSZDriveUrl: '',
      notify: null,
      driveNo: '',
      isPhoneTrue: true,
      code: '',
      leftTime: 60,
      cansend: true,
      isCodeTrue: true,
      isDriveNoTrue: true,
      isJsDriveFileTrue: true,
      isDriveFileTrue: true,
      isDriveFileNoTrue: true,
      isNameTrue: true,
      driveFileNo: '',
      isDriveBarCodeTrue: true,
      driveBarCode: '',
      showName: false,
      error: '',
      chooseType: '',

      payType: 'alipay',
      system: {},
      showDialog: false,
      showpay: false,

      showPayEnd: false,
      orderId: 0,

      useCoupon: false,
      couponId: 0,
      couponFee: 0,
      couponLen: 0,

      DzyNotice: null,
      advertisingShow: advertisingShow(),
    };
  },
  activated() {
    const couponDataCouponId = this.$store.getters.couponId;
    const couponData = this.$store.getters.coupondata;
    if (couponDataCouponId) {
      this.couponId = couponDataCouponId;
      this.couponFee = Number(couponData.Usable.find(item => item.id === couponDataCouponId).CheckReduceFee);
      this.useCoupon = true;
    }
  },
  computed: {
    userInfo() {
      return this.$store.state.userInfo || this.$store.getters.userInfo;
    },
  },
  destroyed() {
    console.log('---destroyed');
    this.$store.commit('SET_COUPONDATA', null);
    this.$store.commit('SET_COUPONDID', '');
  },
  watch: {
    phone(val) {
      if (val.length > 11) {
        this.phone = val.substring(0, 11);
      }
    },
  },
  methods: {
    handleShowNotice() {
      this.$showModal({
        title: this.DzyNotice.Title,
        content: this.DzyNotice.Content,
        confirmText: '我知道了',
      });
    },
    getNotice() {
      this.$request('v3/violation/view/notice').then((xhr, res) => {
        if (res.code === 0 && res.data) {
          if (res.data.DzyHave) {
            this.DzyNotice = res.data.DzyNotice;
          }
        } else {
          this.DzyNotice = null;
        }
      }).catch((e) => {
        console.log(e);
        this.DzyNotice = null;
      });
    },
    gotoCoupon() {
      this.$router.push({
        path: '/formWrap/couponNow',
      });
    },
    // 查看是否有券
    checkStatus(fee) {
      this.$requestPost('v5/client_coupon/user/check/list', {
        apply: 2, // 对应的业务
        max_amount: fee || this.ownFree * 100,
      }).then((xhr, res) => {
        if (res.code === 0) {
          if (res.data && res.data.Usable && res.data.Usable.length) {
            this.couponLen = res.data.Usable.length;
          }
          this.$store.commit('SET_COUPONDATA', res.data);
        }
      });
    },
    gotoHelp() {
      this.$router.push({
        path: '/help',
      });
    },
    confirmFn() {
      this.$router.push({
        path: '/success1',
        query: {
          orderId: this.orderId,
        },
      });
    },
    closePay() {
      this.showpay = false;
      clearInterval(this.timer);
    },
    getPayStatus() {
      const self = this;
      this.$request('/v3/violation/order/poll', {
        order_id: this.out_trade_no,
      }).then((xhr, res) => {
        if (res.code === 0 && res.data === 1) {
          self.showpay = false;
          clearInterval(self.timer);
          self.$router.push({
            path: '/success1',
          });
        }
      });
    },
    changeType(val) {
      this.payType = val;
    },
    chooseImage(type) {
      this.chooseType = type;
      this.$refs.file.value = '';
      this.$refs.file.click();
    },
    // 上传
    uploader() {
      const list = this.$refs.file.files;
      const item = {
        name: list[0].name,
        size: list[0].size,
        file: list[0],
      };
      this.html5Reader(list[0], item);
    },
    html5Reader(file, item) {
      const imgSrc = new Image();
      const reader = new FileReader();
      reader.onload = (e) => {
        imgSrc.src = e.srcElement.result;
        this.$set(item, 'src', e.srcElement.result);
        const self = this;
        imgSrc.onload = function () {//eslint-disable-line
          // 图片原始尺寸
          const originWidth = this.width;
          const originHeight = this.height;
          // 最大尺寸限制
          const maxWidth = 2000;
          const maxHeight = 2000;
          // 目标尺寸
          let targetWidth = originWidth;
          let targetHeight = originHeight;
          // 图片尺寸超过400x400的限制
          if (originWidth > maxWidth || originHeight > maxHeight) {
            if (originWidth / originHeight > maxWidth / maxHeight) {
              // 更宽，按照宽度限定尺寸
              targetWidth = maxWidth;
              targetHeight = Math.round(maxWidth * (originHeight / originWidth));
            } else {
              targetHeight = maxHeight;
              targetWidth = Math.round(maxHeight * (originWidth / originHeight));
            }
          }
          const canvas = document.getElementById('canvas');
          const context = canvas.getContext('2d');
          // canvas对图片进行缩放
          canvas.width = targetWidth;
          canvas.height = targetHeight;
          // 清除画布
          context.clearRect(0, 0, targetWidth, targetHeight);
          // 图片压缩
          context.drawImage(imgSrc, 0, 0, targetWidth, targetHeight);
          const data = canvas.toDataURL('image/jpeg').split(',')[1];
          // 获取base64图片大小，返回MB数字
          const size = parseInt(data.length - (data.length / 4), 10);
          if (size) {
            const isLt2M = size / 1024 / 1024 < 2;
            if (!isLt2M) {
              self.$showToast({ title: '图片大小需要小于 2MB!' });
              return;
            }
            self.$showToast({ title: '正在上传' });
            self.$requestPost('v3/violation/image/upload', {
              imageString: data,
            }).then((xhr, res) => {
              if (res.code === 0) {
                self.$showToast({ title: '上传成功' });
                if (self.chooseType === 'ticket') {
                  self.ticketUrl = res.data;
                } else if (self.chooseType === 'JSZTravel') {
                  self.JSZTravelUrl = res.data;
                } else if (self.chooseType === 'JSZDrive') {
                  self.JSZDriveUrl = res.data;
                } else if (self.chooseType === 'travelUrl') {
                  self.travelUrl = res.data;
                } else if (self.chooseType === 'driveUrl') {
                  self.driveUrl = res.data;
                }
              } else {
                self.$showToast({ title: res.msg });
              }
            });
          }
        };
      };
      reader.readAsDataURL(file);
    },
    // 立即办理
    formSubmit() {
      this.isDriveNoTrue = true;
      this.isPhoneTrue = true;
      this.isCodeTrue = true;
      this.isJsDriveFileTrue = true;
      this.isDriveFileTrue = true;
      this.isNameTrue = true;
      this.error = '';
      const drivenoReg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
      const telReg = /^1[3|4|5|6|7|8|9][0-9]{9}$/;
      if (!this.tel) {
        if (!telReg.test(this.phone)) {
        // swan.showToast({
        //   title: '请输入正确的手机号码'
        // })
          this.isPhoneTrue = false;
          this.error = '手机号码错误，请输入正确的手机号码。';
          return;
        }
      }
      if (this.showName && !this.name) {
        this.isNameTrue = false;
        this.error = '姓名错误，请输入正确的姓名。';
        return;
      }
      if (
        this.illegal.FreeRuleObject &&
      this.illegal.FreeRuleObject.drive_no === 1
      ) {
        if (!drivenoReg.test(this.driveNo)) {
          this.isDriveNoTrue = false;
          this.error = '驾驶证号错误，请输入正确的驾驶证号。';
          return;
        }
      }
      if (
        this.illegal.FreeRuleObject &&
      this.illegal.FreeRuleObject.drive_file_number === 1
      ) {
        if (!this.driveFileNo) {
          this.isDriveFileNoTrue = false;
          this.error = '行驶证档案编号错误，请输入正确的行驶证档案编号。';
          return;
        }
      }
      if (
        this.illegal.FreeRuleObject &&
      this.illegal.FreeRuleObject.drive_bar_code === 1
      ) {
        if (!this.driveBarCode) {
          this.isDriveBarCodeTrue = false;
          this.error = '行驶证条形码号错误，请输入正确的行驶证条形码号。';
          return;
        }
      }
      if (
        this.illegal.FreeRuleObject &&
      this.illegal.FreeRuleObject.drive_licence === 1
      ) {
        if (this.driveUrl === '') {
          this.isDriveFileTrue = false;
          this.error = '请先上传行驶证正面照。';
          return;
        }
      }
      if (
        this.illegal.FreeRuleObject &&
      this.illegal.FreeRuleObject.travel_licence === 1
      ) {
        if (this.travelUrl === '') {
          this.isDriveFileTrue = false;
          this.error = '请先上传行驶证反面照。';
          return;
        }
      }
      if (
        this.illegal.FreeRuleObject &&
      this.illegal.FreeRuleObject.jsz_drive_licence === 1
      ) {
        if (this.JSZDriveUrl === '') {
          this.isJsDriveFileTrue = false;
          this.error = '请先上传驾驶证正面照。';
          return;
        }
      }
      if (
        this.illegal.FreeRuleObject &&
      this.illegal.FreeRuleObject.jsz_travel_licence === 1
      ) {
        if (this.JSZTravelUrl === '') {
          this.isJsDriveFileTrue = false;
          this.error = '请先上传驾驶证反面照。';
          return;
        }
      }
      if (this.payType === 'cmbchina2') {
        this.GenerateOrders();
      } else {
        this.showDialog = true;
      }
    },
    // 生成订单
    GenerateOrders() {
      const self = this;
      const price = Number(this.price * 100);
      const totalPrice = Number(price + this.ownFree + this.lateFree);
      const param = {
        fine: price, // 罚金
        ownFree: this.ownFree, // 服务费用
        totalPrice, // 总金额
        vio_time: this.date, // 文章时间：格式：2017-12-13
        carno: this.illegal.CarNo || '',
        vio_id: this.illegal.ViolationId || '',
        drive_bar_code: this.driveBarCode,
        drive_file_number: this.driveFileNo,
        mobile: this.phone,
        drive_no: this.driveNo, // 驾驶证号
        drive_url: this.driveUrl || '', // 行驶证正面
        travel_url: this.travelUrl || '', // 行驶证反面
        jsz_drive_url: this.JSZDriveUrl || '', // 驾驶证正面
        jsz_travel_url: this.JSZTravelUrl || '', // 驾驶证反面
        vin: this.illegal.vin || '',
        engion: this.illegal.engion || '',
      };
      if (this.showName) {
        param.name = this.name;
      }
      if (this.useCoupon) {
        param.coupon_id = this.couponId;
        param.totalPrice -= this.couponFee;
      }
      if (this.payType === 'wechat_web') {
        param.pay_method = 'wechat_web';
        param.client_ip = '';
        const city = window.returnCitySN;
        if (city) {
          param.client_ip = city.cip;
        }
        const ua = navigator.userAgent.toLowerCase();
        // if (!this.system.win && !this.system.mac && !this.system.xll) {
        if (ua.match(/MicroMessenger/i) === 'micromessenger') {
          param.pay_method = 'wechat_app';
        } else {
          param.pay_method = 'wechat_h5';
        }
        // }
      } else if (this.payType === 'cmbchina2') {
        window.location.href = `https://mys4s.cn/v3/violation/web/order/create?pay_method=cmbchina2&fine=${param.fine
        }&ownFree=${param.ownFree}&vio_id=${param.vio_id}&totalPrice=${param.totalPrice
        }&drive_bar_code=${param.drive_bar_code}&vio_time=${param.vio_time}&drive_file_number=${param.drive_file_number
        }&carno=${param.carno}&mobile=${param.mobile}&drive_url=${param.drive_url}&drive_no=${param.drive_no
        }&vin=${param.vin}&engion=${param.engion}&name=${param.name}&drive_no=${param.drive_no}&jsz_travel_url=${param.jsz_travel_url
        }&travel_url=${param.travel_url}&jsz_drive_url=${param.jsz_drive_url}&access_token=${this.access_token}&channel=${this.channel}&t=${this.t}`;
        return;
      }
      // v2/car/vio_order
      this.$request('v3/violation/web/order/create', param).then((xhr, res) => {
        if (res.code === 20022) {
          self.$router.push({
            path: '/login',
            query: {
              redirect: '/ticketPay',
            },
          });
          return;
        }
        if (res.code >= 40000 && res.code < 50000) {
          self.$router.push({
            path: '/login',
            query: {
              redirect: '/ticketPay',
            },
          });
          return;
        }
        this.showDialog = false;
        if (res.code === 0) {
          // console.log(this.system.win || this.system.mac || this.system.xll);
          if (this.system.win || this.system.mac || this.system.xll) { // 如果是电脑跳转到
            self.paysrc = this.payType === 'wechat_web' ? res.data.CodeImg : res.data.qr_code_img;
            self.out_trade_no = res.data.out_trade_no;
            self.showpay = true;
            self.timer = setInterval(self.getPayStatus, 1000);
          } else if (self.payType === 'wechat_web') {
            // window.location.href = res.data.MwebUrl
            const ua = navigator.userAgent.toLowerCase();
            const { data } = res;
            if (ua.match(/MicroMessenger/i) === 'micromessenger') {
              if (typeof WeixinJSBridge === 'undefined') {
                this.$showToast({ title: '支付失败,请稍后再试' });
              } else {
                WeixinJSBridge.invoke(//eslint-disable-line
                  'getBrandWCPayRequest', {
                    appId: data.appId, // 公众号名称，由商户传入
                    timeStamp: data.timeStamp || data.timestamp, // 时间戳，自1970年以来的秒数
                    nonceStr: data.nonceStr, // 随机串
                    package: data.package,
                    signType: data.signType, // 微信签名方式：
                    paySign: data.paySign, // 微信签名
                  },
                  (ress) => {
                    if (ress.err_msg === 'get_brand_wcpay_request:ok') {
                      self.$router.replace({
                        path: '/success1',
                        query: {
                          orderId: res.data.out_trade_no.split('-')[1],
                        },
                      });
                    }
                  },
                );
              }
            } else if (res.data && res.data.MwebUrl) {
              self.$refs.newWebpay.href = res.data.MwebUrl;
              // self.MwebUrl = res.data.MwebUrl
              self.$refs.newWebpay.click();
            }
          } else if (this.payType === 'unionpay') {
            if (res.data && res.data.tn) {
              upsdk.pay({
                tn: res.data.tn,
                success: () => {
                  window.location.href = "https://mys4s.cn/static/vio/index.html#/ticket?channel=unionpay"
                },
                fail: (e) => {
                }
              })
            }
            return
          } else {
            window.location.href = res.data.qr_code;
          }
          this.showPayEnd = true;
          const [id] = res.data.out_trade_no.split('-')[1];
          this.orderId = id;
        } else {
          this.$showToast({ title: res.msg });
        }
      }).catch((e) => {
        console.log(e);
        this.showDialog = false;
      });
    },
    gotoSuccess() {
      this.$router.replace({
        path: '/success1',
        // query: {
        //   orderId: res.data.out_trade_no.split('-')[1],
        // },
      });
    },
  },
  mounted() {
    const nowChannel = this.advertisingShow.channel;
    const notShowWeixinPay = ['xcarillegal', 'xcarticket']; //   这个数组里的channel 不展示  微信支付
    if (notShowWeixinPay.indexOf(nowChannel) !== -1) {
      this.showWeixinPay = false;
    }
    if (this.advertisingShow.channel === 'cmbapp' || this.advertisingShow.channel === 'cmbchange') {
      this.payType = 'cmbchina2';
      this.access_token = this.$store.getters.token;
      this.channel = window.localStorage.viochannel;
      this.t = (new Date()).getTime();
    }
    if (this.userInfo && this.userInfo.Tel) {
      this.phone = this.userInfo.Tel && this.userInfo.Tel.substring(0, 11);
    }
    // const p = navigator.platform;
    // this.system.win = p.indexOf('Win') >= 0;
    // this.system.mac = p.indexOf('Mac') >= 0;
    // this.system.x11 = (p === 'X11') || (p.indexOf('Linux') >= 0);
    this.system.win = false;
    this.system.mac = false;
    this.system.x11 = false;
    const illegal = this.$store.state.illegalPayData || this.$store.getters.illegalPayData;
    this.illegal = illegal;
    this.price = Number(illegal.Fine);
    this.date = illegal.OccTime.substring(0, 10);
    this.provice = illegal.CarNo ? illegal.CarNo.substring(0, 1) : '';

    if (illegal.CarNo && illegal.CarNo.substring(0, 1) === '豫') {
      // 豫  需要填写姓名
      this.showName = true;
    }

    this.$request('v3/violation/submit_rule', {
      vio_id: this.illegal.ViolationId,
      car_no: this.illegal.CarNo,
      city_code: this.illegal.Locationid,
    }).then((xhr, res) => {
      if (res.code === 0) {
        if (!this.illegal.FreeRuleObject) {
          this.illegal.FreeRuleObject = {};
        }
        this.ownFree = res.data.CooperFee ? Number(res.data.CooperFee) : 0;
        this.illegal.FreeRuleObject.drive_no = res.data.NeedJszNo;// 驾驶证号
        this.illegal.FreeRuleObject.drive_file_number = res.data.NeedJszFileNo;// 驾驶证档案编号
        this.illegal.FreeRuleObject.drive_bar_code = res.data.NeedJszBarCode;// 驾驶证条形码

        this.illegal.FreeRuleObject.drive_licence = res.data.NeedXszFront; // 行驶证正面
        this.illegal.FreeRuleObject.travel_licence = res.data.NeedXszBack;// 行驶证反面

        this.illegal.FreeRuleObject.jsz_drive_licence = res.data.NeedJszFront;// 驾驶证正面
        this.illegal.FreeRuleObject.jsz_travel_licence = res.data.NeedJszBack;// 驾驶证反面

        this.checkStatus(res.data.CooperFee);
      } else {
        this.$showToast({
          icon: 'none',
          title: res.msg,
        });
      }
    }).catch((e) => {
      console.log(e);
      this.$showToast({
        icon: 'none',
        title: '服务器繁忙，请重试',
      });
    });
    this.getNotice();
  },
};
</script>

<style lang="scss" scoped>
.s4s-pay-bg {
  background: #00a1ee url(../assets/icon/head_bg.png) no-repeat left bottom / 100%
    50px;
  width: 100%;
  height: 140px;
}

.s4s-tips {
  /* background: #fff; */
  border-radius: 2px;
  /* padding: 10px; */
  margin-bottom: 10px;
  font-size: 12px;
  display: flex;
  align-items: center;
  background-image: linear-gradient(-90deg, #3A82FF 10%, #115FF8 100%);
}
.s4s-tips-right {
  flex: 1;
  display: flex;
  flex-direction: column;
  font-size: 12px;
  background: #fff;
  padding: 10px 15px;
  line-height: 20px;
  color:#9C9EA8;

}
.s4s-tips-iamge {
  margin: 10px;
  width: 30px;
  height: 30px;
}

.s4s-group image {
  width: 20px;
  height: 20px;
}
.s4s-help {
  width: 15px;
  height: 15px;
  font-size: 12px;
  line-height: 15px;
}
.s4s-sum {
  margin: 20px 10px 0 10px;
  flex: 1;
  align-items: center;
  text-align: left;
  font-size: 15px;
  color: #50b0de;
}
.s4s-sum text {
  color: #f40;
  padding-right: 5px;
}
.s4s-user-btn {
  color:#9c9ea8;
  // font-size: .24rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.s4s-right-arr {
  height: 14px;
  width: 7px;
  margin-left: 10.5px;
}
.red{
  color: #fd2900 !important;
}
</style>
